export class ActionScheduler {

    private timer?: number;
    private generation = 0;
    private destroyed = false;

    public cancel(): void {

        this.generation++;
        if (this.timer !== undefined) {
            window.clearTimeout(this.timer);
            this.timer = undefined;
        }
    }

    public schedule(
        delay: number,
        action: (isCurrent: () => boolean) => void | Promise<void>,
        onError?: (error: unknown) => void
    ): void {

        this.cancel();
        if (this.destroyed) {
            return;
        }
        const generation = this.generation;
        this.timer = window.setTimeout(() => {
            this.timer = undefined;
            if (!this.destroyed && generation === this.generation) {
                void this.execute(generation, action, onError);
            }
        }, delay);
    }

    public destroy(): void {

        this.destroyed = true;
        this.cancel();
    }

    private async execute(
        generation: number,
        action: (isCurrent: () => boolean) => void | Promise<void>,
        onError?: (error: unknown) => void
    ): Promise<void> {

        const isCurrent = () => !this.destroyed && generation === this.generation;
        try {
            await action(isCurrent);
        } catch (error) {
            if (isCurrent()) {
                if (onError) {
                    onError(error);
                } else {
                    console.error("Unable to execute scheduled action", error);
                }
            }
        }
    }
}